import { CartButtonWidgetElement } from './define-cart-button-element';

export function registerCartButtonWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-cart-button')) return;

  window.customElements.define('adipa-cart-button', CartButtonWidgetElement);
}
